import loadingSvg from 'public/images/common/loading.svg';
import React from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import styles from './index.module.scss';

export const Loading: React.FC = () => {
  return (
    <div className={styles.spinner}>
      <div className={styles.spinnerIcon}>
        <NextImage src={loadingSvg} alt="loading" width={120} height={124} />
      </div>
      <p className={styles.spinnerText}>Loading</p>
    </div>
  );
};
